import type { Nullish } from '@iheartjane/types';
import { useCallback, useState } from 'react';

import { setCookie } from '@jane/bloom/utils/cookie.client';
import { durations } from '@jane/bloom/utils/durations';
import type { PromptsType } from '@jane/bloom/utils/prompts';
import { getPromptCookieName } from '@jane/bloom/utils/prompts';

interface UsePromptProps {
  cookiePrefix: Nullish<string>;
  dismissible: boolean;
  expiresAfter?: number;
  prompt: PromptsType;
}

export const usePrompt = ({
  cookiePrefix,
  dismissible,
  expiresAfter = durations.ONE_DAY,
  prompt,
}: UsePromptProps): [boolean, () => void] => {
  const [isPromptVisible, setIsPromptVisible] = useState(true);

  const dismissPrompt = useCallback(() => {
    if (!dismissible) {
      return;
    }
    const cookieName = getPromptCookieName(prompt, cookiePrefix);
    setCookie(cookieName, 'dismissed', expiresAfter);
    setIsPromptVisible(false);
  }, [cookiePrefix, expiresAfter, dismissible, prompt]);

  return [isPromptVisible, dismissPrompt];
};
